import React from 'react';
import './Mission.css';

function Mission() {
  return (
    <div className='mission-container'>
      <div className='mission-content'>
        <h1 className='mission-title'>PediaBright</h1>
        <h2 className='mission-subtitle'>Who Are We</h2>
        <p className='mission-text'>
          Oftentimes, children with complex health conditions have trouble
          understanding their healthcare journey. PediaBright provides tools to
          overcome communication barriers between pediatric patients and
          providers. Our mission is to advance communication in children's
          healthcare while supporting children through their healthcare journey.
        </p>
      </div>
    </div>
  );
}

export default Mission;
